export const institutionsWithLogo = ['ILUNI', 'BIU', 'SBC', 'PIMA', 'FGU', 'AIMS', 'AES'];
